module.exports = __webpack_public_path__ + "static/media/watchlist-delete.f7251109.svg";